import { render, staticRenderFns } from "./PermissionSelector.vue?vue&type=template&id=055ecfe7&scoped=true&lang=pug&"
import script from "./PermissionSelector.vue?vue&type=script&lang=js&"
export * from "./PermissionSelector.vue?vue&type=script&lang=js&"
import style0 from "./PermissionSelector.vue?vue&type=style&index=0&id=055ecfe7&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055ecfe7",
  null
  
)

export default component.exports